import { MessageSquare, Heart } from "lucide-react";

const REVIEWS = [
  {
    user: "RJ",
    color: "text-emerald-400",
    time: "Yesterday at 3:40 PM",
    text: "best prices in the market rn tap in literally only took 2 minutes",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/2ns17fyg_IMG_2681.jpeg",
    alt: "BO2 camo unlock screen with Diamond equipped",
  },
  {
    user: "M1ke4x",
    color: "text-emerald-400",
    time: "Yesterday at 4:23 PM",
    text: "Peacekeeper build maxed out",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/5vqfmqw6_IMG_2682.jpeg",
    alt: "BO2 Custom 1 loadout Peacekeeper Level Max screenshot",
  },
  {
    user: "Luis",
    color: "text-emerald-400",
    time: "Yesterday at 4:24 PM",
    text: "Legittttt 🦍🦍🙏",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/5jo8vsp5_IMG_2683.jpeg",
    alt: "BO2 Custom class with maxed attachments and perks",
  },
  {
    user: "Satly",
    color: "text-emerald-400",
    time: "Yesterday at 5:47 PM",
    text: "Legit",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/p2mbixv1_IMG_2684.jpeg",
    alt: "BO2 Level 55 Prestige 2 screenshot on PS4",
  },
  {
    user: "rixhmike",
    color: "text-emerald-400",
    time: "Yesterday at 6:11 PM",
    text: "100% legit",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/r95kav66_IMG_2685.jpeg",
    alt: "BO2 camo menu with Gold and Diamond unlocked",
  },
  {
    user: "sixty2",
    color: "text-emerald-400",
    time: "Yesterday at 6:31 PM",
    text: "legit // was done in less than 5 mins 🔥",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/40dkavru_IMG_2675.jpeg",
    alt: "BO2 camo screen with Diamond equipped on assault rifle",
  },
  {
    user: "Saved",
    color: "text-red-400",
    time: "Yesterday at 6:58 PM",
    text: "Absolutely safe and quick!! thank you guys! Will buy again.",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/8q9xe4wl_IMG_2677.jpeg",
    alt: "BO2 camo screen Diamond highlighted with SMG",
  },
  {
    user: "Kenneth",
    color: "text-emerald-400",
    time: "Yesterday at 9:25 PM",
    text: "Legit. This was probably completed in 5 seconds… 🔥🔥🔥",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/mfuvh8hm_IMG_2678.jpeg",
    alt: "BO2 camo grid with Diamond unlocked",
  },
  {
    user: "Sᵗussy",
    color: "text-emerald-400",
    time: "Today at 1:39 PM",
    text: "Full legit, very quick & pro",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/px45f6nj_IMG_2679.jpeg",
    alt: "BO2 MSMC full camo grid unlocked (French UI)",
  },
  {
    user: "the man in black",
    color: "text-emerald-400",
    time: "Today at 1:52 PM",
    text: "These guys are the goats only took like 30 seconds will come back for bo1",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/9k7it69s_IMG_2680.jpeg",
    alt: "BO2 sniper with Diamond camo unlocked",
  },
  {
    user: "Big Al",
    color: "text-emerald-400",
    time: "Today at 3:32 PM",
    text: "Whole process happened in just under 30 minutes, very quick and easy",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/419m7249_IMG_2670.jpeg",
    alt: "BO2 DSR-50 sniper with Diamond camo unlocked",
  },
  {
    user: "mollyinmycup",
    color: "text-emerald-400",
    time: "Today at 3:40 PM",
    text: "got my prestige master in less than a minute, thanks to @Admin | iMaxis ❤️",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/mx0dls9f_IMG_2671.jpeg",
    alt: "BO2 Prestige Master playercard shown in lobby list",
  },
  {
    user: "future_gohan",
    color: "text-emerald-400",
    time: "Today at 3:43 PM",
    text: "Legit 100%",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/sog2layt_IMG_2672.jpeg",
    alt: "BO2 multiplayer lobby confirming account access",
  },
  {
    user: "Dotor Doofenshmirtz",
    color: "text-emerald-400",
    time: "Today at 3:51 PM",
    text: "Done in less than 3 minutes 💯✅",
    image:
      "https://customer-assets.emergentagent.com/job_prestige-forge-2/artifacts/5124y2xr_IMG_2673.jpeg",
    alt: "BO2 multiplayer main menu (Spanish UI)",
  },
];

const initials = (name) => {
  const parts = name.replace(/[^a-zA-Z0-9 ]/g, "").split(/\s+/);
  return (parts[0]?.[0] || "?").toUpperCase() + (parts[1]?.[0] || "").toUpperCase();
};

export default function Reviews() {
  return (
    <div className="mx-auto max-w-7xl">
      <div className="mb-14 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
        <div className="max-w-2xl">
          <div className="font-mono-hud text-xs uppercase tracking-[0.4em] text-[#ff6b00]">
            // Field Reports
          </div>
          <h2 className="mt-3 font-display text-5xl uppercase tracking-tight text-zinc-100 sm:text-6xl">
            Verified <span className="text-[#ff6b00]">Kills</span>
          </h2>
          <p className="mt-4 font-hud text-lg text-zinc-400">
            Real Discord posts from players who ran the service. Screenshots straight
            off their consoles. Zero edits.
          </p>
        </div>
        <div className="flex items-center gap-3 border border-zinc-800 bg-black px-4 py-3">
          <div className="grid h-8 w-8 place-items-center border border-[#ff6b00]/50 bg-[#ff6b00]/10">
            <MessageSquare className="h-4 w-4 text-[#ff6b00]" />
          </div>
          <div className="font-mono-hud text-[11px] uppercase tracking-widest text-zinc-400">
            #biipod-reviews
            <span className="ml-2 text-[#ff6b00]">● live</span>
          </div>
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="reviews-grid">
        {REVIEWS.map((r, i) => (
          <ReviewCard key={r.user} review={r} index={i} />
        ))}
      </div>

      <div className="mt-10 flex flex-col items-start gap-3 border border-zinc-800 bg-black px-5 py-4 sm:flex-row sm:items-center sm:justify-between" data-testid="reviews-cta">
        <p className="font-hud text-sm text-zinc-300">
          <span className="font-mono-hud uppercase tracking-widest text-[#ff6b00]">
            15+ verified orders
          </span>{" "}
          in the last 24 hours. Ready to run yours?
        </p>
        <a
          href="#order"
          className="inline-flex items-center border-2 border-[#ff6b00] bg-[#ff6b00] px-5 py-2.5 font-hud text-sm font-semibold uppercase tracking-widest text-black transition-transform duration-150 hover:-translate-y-0.5 hover:bg-[#ff8125]"
          data-testid="reviews-cta-button"
        >
          Initiate Order
        </a>
      </div>
    </div>
  );
}

function ReviewCard({ review, index }) {
  return (
    <article
      className="group relative flex flex-col border border-zinc-800 bg-[#0a0a0a] transition-colors duration-150 hover:border-[#ff6b00]/60"
      data-testid={`review-${index}`}
    >
      <header className="flex items-center gap-3 border-b border-zinc-900 bg-black px-4 py-3">
        <div className="grid h-9 w-9 flex-none place-items-center border border-[#ff6b00]/40 bg-zinc-950 font-display text-sm text-[#ff6b00]">
          {initials(review.user)}
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2">
            <span className={`font-hud text-sm font-semibold ${review.color}`}>
              {review.user}
            </span>
            <Heart className="h-3 w-3 flex-none text-[#ff4a6b]" fill="currentColor" />
            <span className="font-mono-hud text-[10px] uppercase tracking-widest text-zinc-500">
              {review.time}
            </span>
          </div>
          <div className="mt-0.5 font-mono-hud text-[10px] uppercase tracking-widest text-zinc-600">
            via discord · verified order
          </div>
        </div>
      </header>

      <p className="px-4 pt-4 font-hud text-sm text-zinc-200">{review.text}</p>

      <div className="mt-4 border-t border-zinc-900 bg-black p-3">
        <div className="relative overflow-hidden border border-zinc-900">
          <img
            src={review.image}
            alt={review.alt}
            loading="lazy"
            className="block h-64 w-full object-cover transition-transform duration-300 group-hover:scale-[1.02]"
            data-testid={`review-${index}-image`}
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
          <div className="pointer-events-none absolute bottom-2 left-2 border border-[#ff6b00]/60 bg-black/80 px-2 py-1 font-mono-hud text-[9px] uppercase tracking-widest text-[#ff6b00]">
            ✔ delivered
          </div>
        </div>
      </div>
    </article>
  );
}
